import navigator from './navigator';

export const MOBILE = !!navigator.userAgent.match(/(iPad|iPhone|android)/i);
export const IE = !!navigator.userAgent.match(/(Trident\/|MSIE )/i);
export const MACOS = !!navigator.platform.match(/Mac/i);
